import React from 'react'
import ReactHtmlParser from 'react-html-parser'; 
import { useSubBuilder } from '../../../../context/subBuilder/useSubBuilder';
import IconBackArrow from '../../../svgs/BackArrow';

interface Props {
  index: number
  title: string
  introText: string
}

const Intro: React.FunctionComponent<Props> = ({ index, title, introText }) => {
  const {actions } = useSubBuilder()
  return (
    <header className="sub-builder-intro sub-builder-container-sm">
      {index > 1 && (
        <button type="button" className="btn-back" onClick={() => actions.moveStep(-1)}>
          <IconBackArrow />
          <span>Back</span>
        </button>)
      }
      <div className="flex align-start">
        <div className="sub-builder-intro-index">{`${index}.`}</div>
        <div>
          <div className="sub-builder-intro-title text-upper">{ title }</div>
          <div className="sub-builder-intro-text">{ ReactHtmlParser(introText) }</div>
        </div>
      </div>
    </header>
  )
}

export default Intro  
